import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

export interface RecommendationItem {
  title: string;
  reason: string;
  url?: string;
  mediaType?: string;
}

export interface MediaTypeOption {
  key: string;
  label: string;
  icon: string;
}

@Component({
  selector: 'tangram-content-recommendation-selector',
  templateUrl: './content-recommendation-selector.component.html',
  styleUrls: ['./content-recommendation-selector.component.scss'],
})
export class ContentRecommendationSelectorComponent implements OnInit {
  @Input() isLoading: boolean = false;
  @Input() recommendations: RecommendationItem[] = [];

  @Output() search      = new EventEmitter<{ topic: string; mediaType: string }>();
  @Output() addContent  = new EventEmitter<RecommendationItem>();

  topicInput     = '';
  selectedType   = 'all';
  selectedItems  = new Set<string>();

  readonly mediaTypes: MediaTypeOption[] = [
    { key: 'all',     label: 'All',      icon: 'grid' },
    { key: 'video',   label: 'Video',    icon: 'video' },
    { key: 'article', label: 'Article',  icon: 'file-text' },
    { key: 'image',   label: 'Image',    icon: 'image' },
    { key: 'audio',   label: 'Audio',    icon: 'music' },
    { key: 'pdf',     label: 'PDF',      icon: 'file' },
  ];

  ngOnInit(): void {}

  selectType(key: string): void {
    this.selectedType = key;
  }

  triggerSearch(): void {
    if (!this.topicInput.trim()) { return; }
    this.selectedItems.clear();
    this.search.emit({ topic: this.topicInput.trim(), mediaType: this.selectedType });
  }

  onEnter(event: KeyboardEvent): void {
    if (event.key === 'Enter') { this.triggerSearch(); }
  }

  get filteredRecommendations(): RecommendationItem[] {
    if (this.selectedType === 'all') { return this.recommendations; }
    return this.recommendations.filter(
      r => !r.mediaType || r.mediaType.toLowerCase() === this.selectedType
    );
  }

  isSelected(item: RecommendationItem): boolean {
    return this.selectedItems.has(item.title);
  }

  toggleSelect(item: RecommendationItem): void {
    if (this.selectedItems.has(item.title)) {
      this.selectedItems.delete(item.title);
    } else {
      this.selectedItems.add(item.title);
    }
  }

  addSelected(): void {
    this.filteredRecommendations
      .filter(r => this.selectedItems.has(r.title))
      .forEach(r => this.addContent.emit(r));
    this.selectedItems.clear();
  }

  get selectedCount(): number {
    return this.selectedItems.size;
  }

  getMediaTypeLabel(key: string | undefined): string {
    if (!key) { return ''; }
    const match = this.mediaTypes.find(m => m.key === key);
    return match ? match.label : key;
  }
}
